import dayjs from 'dayjs';
import roundHalfEven from 'round-half-even';

const getInitialsFromName = (name) => {
  let initials = '';
  if (name?.length > 0) {
    const splitName = name.replace(/\s+/g, ' ').trim().split(' ');
    initials += splitName[0][0];
    if (splitName.length > 1) {
      initials += splitName[splitName.length - 1][0];
    }
  }
  return initials;
};

const isDarkText = (backgroundColor) => {
  if (!backgroundColor) {
    return false;
  }

  let color = backgroundColor.substring(1, backgroundColor.length);
  if (color.length === 3) {
    color += color;
  }

  const red = parseInt(color.substring(0, 2), 16);
  const green = parseInt(color.substring(2, 4), 16);
  const blue = parseInt(color.substring(4, 6), 16);
  return red * 0.299 + green * 0.587 + blue * 0.114 > 186;
};

const currencyFormat = (num) => {
  if (!Number.isNaN(parseFloat(num))) {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    return formatter.format(roundHalfEven(parseFloat(num), 2));
  }
  return '';
};

const formatUtcDate = (date) =>
  typeof date === 'object' || date?.split(' ').length > 2
    ? date
    : `${date.charAt(date.length - 1) === 'Z' ? date : `${date}Z`}`;

const formatUrl = (url) =>
  url.charAt(url.length - 1) === '/' ? url.substring(0, url.length - 1) : url;

const toTitleCase = (str) =>
  str?.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );

const singularPluralFormat = (value, singular, plural) =>
  `${value} ${value === 1 ? singular : plural}`;

const changeListItemSortOrder = (
  list,
  startIndex,
  endIndex,
  dataSelector = null
) => {
  if (startIndex === endIndex) {
    return list;
  }

  const selector = dataSelector || 'sort';
  const isGreaterIndex = endIndex > startIndex;

  const listCopy = [...list];
  for (const element of listCopy) {
    if (element[selector] === startIndex) {
      element[selector] = endIndex;
    }
    else if (
      isGreaterIndex &&
      element[selector] >= startIndex &&
      element[selector] <= endIndex
    ) {
      element[selector] -= 1;
    }
    else if (element[selector] <= startIndex && element[selector] >= endIndex) {
      element[selector] += 1;
    }
  }

  return listCopy;
};

const getDateRangeLabel = (start, end) =>
  start && end
    ? dayjs(start).year() === dayjs(end).year()
      ? `${dayjs(start).format('MMM DD')} - ${dayjs(end).format(
          'MMM DD, YYYY'
        )}`
      : `${dayjs(start).format('MMM DD, YYYY')} - ${dayjs(end).format(
          'MMM DD, YYYY'
        )}`
    : null;

const fixHtmlHrefUrls = (html) =>
  html.replace(/href="(.*?)"/g, (match, url) => {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = `https://${url}`;
    }
    return `href="${url}" target="_blank"`;
  });

const buildQueryString = (obj, fields) => {
  const params = [];
  fields.forEach((field) => {
    if (obj[field] !== undefined) {
      params.push(`${field}=${encodeURIComponent(obj[field])}`);
    }
  });
  return `?${params.join('&')}`;
};

export {
  getInitialsFromName,
  isDarkText,
  currencyFormat,
  formatUtcDate,
  formatUrl,
  toTitleCase,
  singularPluralFormat,
  changeListItemSortOrder,
  getDateRangeLabel,
  fixHtmlHrefUrls,
  buildQueryString
};
